var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef } from "react";
import { HOST_Server, PATH_APICURRENTVERSION, PATH_Recipes, SHOPIFY_CUSTOMPRODUCT, SHOPIFY_DOMAIN, SHOPIFY_STOREFRONTTOKEN } from "../../config/config.dev";
import EditableTextInput from "./EditableTextInput";
import './RecipeView.css';
import './RecipeStyle.css';
import { Button, Grid } from "@mui/material";
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import ShareIcon from '@mui/icons-material/Share';
import '../Navigation/ContextButtons.css';
import EditableDropdownInput from "./EditableDropdownInput";
import MealTypes from '../../dataTypeLists/mealTypes';
import CuisineTypes from "../../dataTypeLists/cusineTypes";
import { buildShareUrl, buildShareUrlEncode } from "../../helpers/urlBuilder";
import Notification from "../Notification/Notification";
import hasNoNullLineItems from "./HasNoNullLineItems";
import EditableMultiLineListInput from "./EditableMultiLineListInput";
import { servingSizes } from "../AutoSuggestions/ServingSizes";
import { placeHolderTitle } from "./Data/NewRecipeData";
import { useLocation } from "react-router-dom";
import { trackPageView, trackException } from "../Telemetry/AppInsights";
import { Telemetry } from "../Telemetry/TelemtryEventNames";
import EditableToggleSwitch from "./EditableToggleSwitch";
import NutritionLabel from "./NutritionalInformation/NutritionalInformation";
import WakeLockSwitch from "../ScreenWakeLock/WakeLockSwitch";
import { setFocusOnElement } from "../../helpers/inputFocusHelper";
import { useAuth0 } from "@auth0/auth0-react";
import { useUpdateRecipe } from "./Data/UpdateRecipeData";
import InlineConfirmationDialog from "../Dialogs/InlineConfirmationDialog";
import { Helmet } from "react-helmet";
import ShopifyBuyButton from "../Shopify/BuyButton";
var RecipeView = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var recipe = _a.recipe, setSelectedRecipe = _a.setSelectedRecipe, isEditable = _a.isEditable, openInEditMode = _a.openInEditMode, resetEditMode = _a.resetEditMode, isShareOnly = _a.isShareOnly, isSpicePack = _a.isSpicePack, isDeepLink = _a.isDeepLink, reloadOnClose = _a.reloadOnClose;
    var _p = useState(false), showNotification = _p[0], setShowNotification = _p[1];
    var _q = useState(""), showNotificationText = _q[0], setShowNotificationText = _q[1];
    var _r = useState(recipe), model = _r[0], setModel = _r[1];
    var _s = useState(false), isEditing = _s[0], setIsEditing = _s[1];
    var _t = useState("Edit"), editingText = _t[0], setEditingText = _t[1];
    var shareText = "Share";
    var deleteText = "Delete";
    var backText = "Back";
    var switchRef = useRef(null);
    var recipeTitleRef = useRef(null);
    var getAccessTokenSilently = useAuth0().getAccessTokenSilently;
    var updateRecipe = useUpdateRecipe();
    var isMounted = useRef(true);
    var _u = useState(false), showShareConfirmation = _u[0], setShowShareConfirmation = _u[1];
    var _v = useState(false), showDeleteConfirmation = _v[0], setShowDeleteConfirmation = _v[1];
    useEffect(function () {
        if (isShareOnly) {
            trackPageView(Telemetry.PageView.SharedRecipe, recipe.id);
        }
        if (isSpicePack) {
            trackPageView(Telemetry.PageView.SpicePackRecipe, recipe.id);
        }
        if (!isSpicePack && !isShareOnly) {
            trackPageView(Telemetry.PageView.UserRecipe, recipe.id);
        }
    }, []);
    var location = useLocation();
    // Override My Recipes & Spice Packs Menu Button to Act as a back button.
    // Using this trick, we don't need to share context or state BUT we relay on
    // these IDs to do the work.
    useEffect(function () {
        var myRecipesNavItem = document.getElementById('MyRecipesNavItem');
        var spicePacksNavItem = document.getElementById('SpicePacksNavItem');
        var handleMyRecipesNavClick = function () {
            if (location.pathname === "/recipes" || location.pathname === "/") {
                var backButton = document.getElementById('PrimaryBackButton');
                if (backButton) {
                    handleBackButton();
                }
            }
        };
        if (myRecipesNavItem) {
            myRecipesNavItem.addEventListener('click', handleMyRecipesNavClick);
        }
        if (spicePacksNavItem) {
            spicePacksNavItem.addEventListener('click', handleMyRecipesNavClick);
        }
        // Cleanup function to remove the event listener when the component is unmounted.
        return function () {
            if (myRecipesNavItem) {
                myRecipesNavItem.removeEventListener('click', handleMyRecipesNavClick);
            }
            if (spicePacksNavItem) {
                spicePacksNavItem.removeEventListener('click', handleMyRecipesNavClick);
            }
        };
    }, [location.pathname]); // Re-run the effect if location.pathname changes
    useEffect(function () {
        var _a;
        window.scrollTo(0, 0);
        if (openInEditMode) {
            setIsEditing(true);
            setEditingText(!isEditing ? "Save" : "Edit"); // Todo merge this into helper.
            var recipeTitleField = (_a = recipeTitleRef === null || recipeTitleRef === void 0 ? void 0 : recipeTitleRef.current) === null || _a === void 0 ? void 0 : _a.getInputRef();
            setFocusOnElement(recipeTitleField, 200);
        }
    }, []);
    // Back Button Scroll Position and set selected recipe
    var handleSetSelectedRecipe = function (recipeModel) {
        if (setSelectedRecipe) {
            setSelectedRecipe(recipeModel);
        }
    };
    var handleUpdateModel = function (newModel) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedModel;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // TODO ADD SAVE ICON
                    // Here- we should make sure we are in total sync with Database. 
                    // Maye require replumbing of save into a save Buffer system
                    setModel(newModel);
                    handleSetSelectedRecipe(newModel);
                    return [4 /*yield*/, updateRecipe(newModel)];
                case 1:
                    updatedModel = _a.sent();
                    // TODO RELEASE SAVEICON
                    // IF a user makes an update, and then hits the back button we want to post the update like we do above, 
                    // but then not return to the page. 
                    // We introduce isMounted, which is true when component is loaded and is false when we hit the back button.
                    // We ensure the current recipe selected is the same as the one updated before we update these values.
                    if (isMounted.current && recipe.id === updatedModel.id) {
                        handleSetSelectedRecipe(updatedModel);
                        setModel(updatedModel);
                        reloadOnClose && reloadOnClose(); // reload if updating a recipe
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleShareUserAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // If the recipe is not public, ask the user to make it public.
            if (!model.isPublic) {
                setShowShareConfirmation(true);
            }
            else {
                // The recipe is already public, copy to clipboard.
                copyToClipboard();
            }
            return [2 /*return*/];
        });
    }); };
    var handleShareConfirm = function () {
        setShowShareConfirmation(false);
        makePublicAndCopy();
    };
    var handleShareCancel = function () {
        setShowShareConfirmation(false);
    };
    function makePublicAndCopy() {
        var _a;
        (_a = switchRef === null || switchRef === void 0 ? void 0 : switchRef.current) === null || _a === void 0 ? void 0 : _a.setSwitchProgrammatically(true);
        copyToClipboard();
    }
    function copyToClipboard() {
        // Generate Link
        var isSpicePackLink = isSpicePack ? isSpicePack : false;
        var encodedData = buildShareUrlEncode(model.userId, model.id);
        var url = model.shortCode ?
            buildShareUrl(model.shortCode, isSpicePackLink) :
            buildShareUrl(encodedData, isSpicePackLink);
        navigator.clipboard.writeText(url).then(function () {
            // clipboard successfully set
            setShowNotification(true);
            setShowNotificationText("Copied!");
            setTimeout(function () {
                setShowNotification(false);
            }, 7000);
        }, function (e) {
            // TODO: On Android, clipboard will fail first time and user has to press button again.
            // clipboard write failed
            // setShowNotification(true);
            // setShowNotificationText("ERROR!" + e);
            // setTimeout(() => {
            //     setShowNotification(false);
            // }, 7000);
        });
    }
    var handleEdit = function () {
        var _a;
        var recipeTitle = (_a = recipeTitleRef === null || recipeTitleRef === void 0 ? void 0 : recipeTitleRef.current) === null || _a === void 0 ? void 0 : _a.getValue();
        if (isEditing && !recipeTitle) {
            // Todo page notificiation?
            return;
        }
        setIsEditing(!isEditing);
        setEditingText(!isEditing ? "Save" : "Edit");
        if (openInEditMode && resetEditMode) {
            resetEditMode();
        }
    };
    //todo move to /data folder as delete helper
    var showDeleteDialog = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setShowDeleteConfirmation(true);
            return [2 /*return*/];
        });
    }); };
    var handleDeleteCancel = function () {
        setShowDeleteConfirmation(false);
    };
    var handleDeleteConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var accessToken;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getAccessTokenSilently()];
                case 1:
                    accessToken = _a.sent();
                    return [4 /*yield*/, fetch("".concat(HOST_Server).concat(PATH_APICURRENTVERSION).concat(PATH_Recipes, "/").concat(recipe.id), {
                            method: "DELETE",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: "Bearer ".concat(accessToken),
                            }
                        })
                            .then(function (response) {
                            if (response.ok) {
                                reloadOnClose && reloadOnClose(); // Reload if deleting a recipe
                                handleSetSelectedRecipe(null);
                            }
                            else {
                                throw new Error("Error deleting recipe");
                            }
                        })
                            .catch(function (error) {
                            console.error(error);
                            var ex = error;
                            trackException(ex);
                        })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleBackButton = function () {
        if (openInEditMode && resetEditMode) {
            resetEditMode();
        }
        isMounted.current = false;
        handleSetSelectedRecipe(null);
    };
    var buttons = [
        { id: "ShareButton", text: shareText, onClick: handleShareUserAction, startIcon: _jsx(ShareIcon, {}) },
        { id: "PrimaryBackButton", text: backText, onClick: handleBackButton, startIcon: _jsx(ArrowBackOutlinedIcon, {}) },
    ];
    if (isShareOnly || isDeepLink) {
        buttons = [
            { id: "ShareButton", text: shareText, onClick: handleShareUserAction, startIcon: _jsx(ShareIcon, {}) },
        ];
    }
    if (isEditable) {
        buttons = [
            { id: "EditButton", text: editingText, onClick: handleEdit, startIcon: _jsx(ModeEditOutlinedIcon, {}) },
            { id: "ShareButton", text: shareText, onClick: handleShareUserAction, startIcon: _jsx(ShareIcon, {}) },
            { id: "PrimaryBackButton", text: backText, onClick: handleBackButton, startIcon: _jsx(ArrowBackOutlinedIcon, {}) },
        ];
        if (openInEditMode) {
            // New Recipe is not yet saved, when this switch is of we can then share the recipe.
            buttons = [
                { id: "EditButton", text: editingText, onClick: handleEdit, startIcon: _jsx(ModeEditOutlinedIcon, {}) },
                { id: "PrimaryBackButton", text: backText, onClick: handleBackButton, startIcon: _jsx(ArrowBackOutlinedIcon, {}) },
            ];
        }
        if (isEditing) {
            buttons = [
                { id: "EditButton", text: editingText, onClick: handleEdit, startIcon: _jsx(ModeEditOutlinedIcon, {}) },
                { id: "DeleteButton", text: deleteText, onClick: showDeleteDialog, startIcon: _jsx(DeleteOutlinedIcon, {}) },
                { id: "PrimaryBackButton", text: backText, onClick: handleBackButton, startIcon: _jsx(ArrowBackOutlinedIcon, {}) },
            ];
        }
    }
    var enableGrouping = (isShareOnly || isSpicePack) &&
        hasNoNullLineItems(recipe.ingredientList) &&
        hasNoNullLineItems(recipe.directionList);
    // Do not render notes on Spice Pack Views
    var notes = isSpicePack ? _jsx("div", {}) :
        _jsx(EditableMultiLineListInput, { isMultiLine: true, numberMultiLineRows: 3, isEditing: isEditing, model: recipe, onUpdateModel: handleUpdateModel, label: "Notes", property: "noteList", inputProperties: { minLength: 0, maxLength: 500 }, maxListItems: 10 });
    // To full render, place {debugNutritionFactsInfo} in JSX
    var debugNutritionFactsFlag = false;
    var debugNutritionFactsInfo = !debugNutritionFactsFlag ? _jsx("div", {}) :
        _jsxs("div", { children: ["Line Item Nutritional Info", recipe.ingredientList.map(function (lineItem, index) {
                    if (lineItem && lineItem.nutritionFacts) {
                        return _jsx(NutritionLabel, { label: lineItem.lineItem, nutrition: lineItem.nutritionFacts, servingsCount: recipe.numberOfServings }, index);
                    }
                    if (lineItem && !lineItem.nutritionFacts) {
                        return _jsxs("p", { children: ["Missing Nutrition Facts: ", lineItem.lineItem] }, index);
                    }
                    return null;
                })] });
    var validImageUrl = recipe.imageUrlList.length > 0 ? recipe.imageUrlList[0].lineItem : 'default.png';
    var validImageAltText = recipe.imageUrlList.length > 0 ? "photo of " + recipe.title : "meal genie default image";
    // Standard Product Buy Button
    // eCommercdId will exist in the metadata and will map to the retail product on the back end
    var eCommerceId = ((_c = (_b = recipe.optionalMetaData) === null || _b === void 0 ? void 0 : _b.meta_SpicePack) === null || _c === void 0 ? void 0 : _c.enabled) && ((_e = (_d = recipe.optionalMetaData) === null || _d === void 0 ? void 0 : _d.meta_SpicePack) === null || _e === void 0 ? void 0 : _e.eCommerceProductId);
    var buyButton = eCommerceId ? _jsx(ShopifyBuyButton, { domain: SHOPIFY_DOMAIN, storefrontAccessToken: SHOPIFY_STOREFRONTTOKEN, productId: eCommerceId, customProductName: recipe.title }) : null;
    // Custom Product Buy Button
    var customSpicePackEnabled = ((_g = (_f = recipe.optionalMetaData) === null || _f === void 0 ? void 0 : _f.meta_SpicePack) === null || _g === void 0 ? void 0 : _g.enabled) &&
        !eCommerceId &&
        ((_k = (_j = (_h = recipe.optionalMetaData) === null || _h === void 0 ? void 0 : _h.meta_SpicePack) === null || _j === void 0 ? void 0 : _j.priceAndWeight) === null || _k === void 0 ? void 0 : _k.weight) > 0 &&
        ((_o = (_m = (_l = recipe.optionalMetaData) === null || _l === void 0 ? void 0 : _l.meta_SpicePack) === null || _m === void 0 ? void 0 : _m.priceAndWeight) === null || _o === void 0 ? void 0 : _o.weight) < 1.75;
    if (customSpicePackEnabled) {
        // Custom Buy Button
        buyButton = _jsx(ShopifyBuyButton, { domain: SHOPIFY_DOMAIN, storefrontAccessToken: SHOPIFY_STOREFRONTTOKEN, productId: SHOPIFY_CUSTOMPRODUCT, customProductId: recipe.id, customProductName: recipe.title, ingredients: recipe.ingredientList });
    }
    return (_jsxs("div", __assign({ className: "recipe-container" }, { children: [_jsxs(Helmet, { children: [_jsxs("title", { children: ["MealGenie.io: ", recipe.title] }), _jsx("meta", { name: "description", content: "MealGenie.io: Your ultimate recipe management platform and spice order service. Discover new recipes, order premade or custom spice packs, and elevate your cooking experience." }), _jsx("meta", { property: "og:title", content: "MealGenie.io: " + recipe.title }), _jsx("meta", { property: "og:description", content: "Discover new recipes, order premade or custom spice packs, and elevate your cooking experience with MealGenie.io." }), _jsx("meta", { property: "og:image", content: "/mealgenielogofav485.png" }), _jsx("meta", { property: "og:url", content: "https://mealgenie.io/" }), _jsx("meta", { property: "og:type", content: "website" }), _jsx("meta", { name: "twitter:card", content: "summary_large_image" }), _jsx("meta", { name: "twitter:title", content: "MealGenie.io: " + recipe.title }), _jsx("meta", { name: "twitter:description", content: "Discover new recipes, order premade or custom spice packs, and elevate your cooking experience with MealGenie.io." }), _jsx("meta", { name: "twitter:image", content: "/mealgenielogofav485.png" })] }), _jsxs("div", __assign({ className: "recipe-dialog" }, { children: [_jsx(InlineConfirmationDialog, { open: showShareConfirmation, message: "To share your recipe, it needs to be public. You can disable this at any time. Would you like to make the recipe public?", onConfirm: handleShareConfirm, onCancel: handleShareCancel }), _jsx(InlineConfirmationDialog, { open: showDeleteConfirmation, message: "Are you sure you want to delete ".concat(recipe.title.trim(), "? This can not be undone."), confirmLabel: "Delete", onConfirm: handleDeleteConfirm, onCancel: handleDeleteCancel })] })), _jsxs("div", __assign({ className: "recipe-body" }, { children: [showNotification && _jsx(Notification, { message: showNotificationText }), _jsxs("div", __assign({ className: "recipe-header" }, { children: [isEditing == false && _jsx("h1", __assign({ className: "recipe-title" }, { children: (recipe.title ? recipe.title : "") })), isEditing == true && _jsx(EditableTextInput, { isRequired: true, ref: recipeTitleRef, isEditing: isEditing, model: recipe, field: recipe.title, label: "Recipe Title", fieldName: "title", onUpdateModel: handleUpdateModel, inputProperties: { minLength: 1, maxLength: 105 }, disableBrowserAutoComplete: true, placeholder: placeHolderTitle })] })), _jsx("div", __assign({ className: "recipe-sub-header" }, { children: _jsxs("div", __assign({ className: "recipeViewSwitches" }, { children: [!isSpicePack && _jsx(EditableToggleSwitch, { ref: switchRef, model: recipe, field: recipe.isPublic, label: recipe.isPublic ? "Public" : "Private", fieldName: "isPublic", isEditing: isEditing, onUpdateModel: handleUpdateModel }), _jsx(WakeLockSwitch, { isEditing: true, fieldName: "Keep display on" }), buyButton && buyButton] })) })), _jsx(EditableTextInput, { noUnderline: true, isMultiLine: true, isEditing: isEditing, model: recipe, field: recipe.description, label: "Description", fieldName: "description", onUpdateModel: handleUpdateModel, inputProperties: { maxLength: 200 }, disableBrowserAutoComplete: true }), _jsxs("div", __assign({ className: "recipe-details-container" }, { children: [_jsxs("div", __assign({ className: "recipe-details" }, { children: [_jsxs(Grid, __assign({ container: true, spacing: 2, columns: 16 }, { children: [_jsx(Grid, __assign({ item: true, xs: 8 }, { children: _jsx(EditableTextInput, { isEditing: isEditing, model: recipe, field: recipe.numberOfServings, label: "Servings", fieldName: "numberOfServings", onUpdateModel: handleUpdateModel, inputProperties: { min: 1, max: 500 }, disableBrowserAutoComplete: true }) })), _jsx(Grid, __assign({ item: true, xs: 8 }, { children: _jsx(EditableTextInput, { isEditing: isEditing, model: recipe, field: recipe.servingSize, label: "Serving Size", placeholder: "eg. one cup, slice, etc", fieldName: "servingSize", onUpdateModel: handleUpdateModel, inputProperties: { maxLength: 30 }, disableBrowserAutoComplete: true, autoSuggestData: servingSizes }) }))] })), _jsxs(Grid, __assign({ container: true, spacing: 2, columns: 16 }, { children: [_jsx(Grid, __assign({ item: true, xs: 8 }, { children: _jsx(EditableTextInput, { isEditing: isEditing, model: recipe, field: recipe.prepTimeInMinutes, label: "Prep Time (minutes)", fieldName: "prepTimeInMinutes", onUpdateModel: handleUpdateModel, placeholder: "0", inputProperties: { min: 0, max: 5000 }, disableBrowserAutoComplete: true }) })), _jsx(Grid, __assign({ item: true, xs: 8 }, { children: _jsx(EditableTextInput, { isEditing: isEditing, model: recipe, field: recipe.cookTimeInMinutes, label: "Cook Time (minutes)", fieldName: "cookTimeInMinutes", onUpdateModel: handleUpdateModel, placeholder: "0", inputProperties: { min: 0, max: 5000 }, disableBrowserAutoComplete: true }) }))] })), _jsxs(Grid, __assign({ container: true, spacing: 2, columns: 16 }, { children: [_jsx(Grid, __assign({ item: true, xs: 8 }, { children: _jsx(EditableDropdownInput, { model: recipe, onUpdateModel: handleUpdateModel, field: recipe.cuisineType, label: "Cuisine", fieldName: "cuisineType", isEditing: isEditing, menuItems: CuisineTypes, renderReadOnlyAsTextField: true }) })), _jsx(Grid, __assign({ item: true, xs: 8 }, { children: _jsx(EditableDropdownInput, { model: recipe, onUpdateModel: handleUpdateModel, field: recipe.mealType, label: "Category", fieldName: "mealType", isEditing: isEditing, menuItems: MealTypes, renderReadOnlyAsTextField: true }) }))] }))] })), _jsx("div", { className: "recipe-image" })] })), (isSpicePack && recipe.nutritionFacts) ? _jsx(NutritionLabel, { nutrition: recipe.nutritionFacts, servingsCount: recipe.numberOfServings, servingSize: recipe.servingSize }) : _jsx("div", {}), _jsx(EditableMultiLineListInput, { label: "Ingredients", property: "ingredientList", inputProperties: { minLength: 0, maxLength: 80 }, maxListItems: 50, numberMultiLineRows: 2, model: recipe, EnableGrouping: enableGrouping, isEditing: isEditing, isSpicePack: isSpicePack, onUpdateModel: handleUpdateModel, isMultiLine: true, renderLinks: true }), _jsx(EditableMultiLineListInput, { label: "Directions", property: "directionList", inputProperties: { minLength: 0, maxLength: 500 }, maxListItems: 30, numberMultiLineRows: 5, model: recipe, EnableGrouping: enableGrouping, isEditing: isEditing, onUpdateModel: handleUpdateModel, isMultiLine: true }), notes, _jsx("div", __assign({ className: 'contextButtonMenu' }, { children: buttons.map(function (button, index) { return (_jsx(Button, __assign({ id: button.id, variant: "outlined", color: button.color == "error" ? "error" : "primary", className: "buttonPadding", startIcon: button.startIcon, onClick: button.onClick }, { children: button.text }), button.id)); }) }))] }))] })));
};
export default RecipeView;
